import React, { Component, useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import axios from "axios";

import { Layout, Row, Col, Table, message, Input } from "antd";
import moment from "moment-timezone";
import numberFormat from "./../../utils/numberFormat";

import { chunk, sumBy, uniq } from "lodash";
import converter from "number-to-words";
import { addKeysToArray, getSignatories } from "../../utils/utilities";
import round from "../../utils/round";
import { getDateTimeNow, edit } from "../../utils/form_utilities";
import isEmpty from "../../validation/is-empty";
import classnames from "classnames";

import { useLocation, useParams } from "react-router-dom";
import { VAT_TYPE_PERCENT } from "../../utils/constants";

const { Content } = Layout;

const title = "Acceptance Report";
const url = "/api/check-vouchers/";
const date_fields = ["date", "check_date"];

export default function CheckVoucherPrintout({
  match,
  reprint = false,
  duplicate = false,
}) {
  const auth = useSelector((state) => state.auth);

  const initialValues = {
    _id: null,
    rr_no: null,
    date: moment(),
    supplier: null,
    warehouse: auth.user?.warehouse,
    remarks: "",
    items: [],

    purchase_order: null,
    stock_release: null,
    sales_return: null,
    customer: null,
  };

  const params = useParams();
  const [state, setState] = useState(initialValues);
  const [date, setDate] = useState(null);

  const [heading_state, setHeadingState] = useState({});

  useEffect(() => {
    axios
      .get("/api/account-settings/company-heading")
      .then((response) => {
        if (response.data) {
          const { ...rest } = response.data;

          setHeadingState((prevState) => {
            return {
              ...rest,
            };
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    return () => {};
  }, []);

  useEffect(() => {
    getSignatories().then((records) => {
      setState((prevState) => ({
        ...prevState,
        ...records,
      }));
    });

    // const listener = window.addEventListener("afterprint", (event) => {
    //   axios
    //     .post(`${url}${match.params.id}/print-status`, {
    //       user: auth.user,
    //     })
    //     .then((response) => {
    //       edit({
    //         record: { _id: response.data._id },
    //         setState,
    //         url,
    //         date_fields,
    //       });
    //     });
    // });

    // const before_print_listener = window.addEventListener(
    //   "beforeprint",
    //   (event) => {
    //     event.preventDefault();
    //     if (isEmpty(auth.user)) {
    //       alert(
    //         "The system is not able to track your user. Please log-out and log-in again."
    //       );
    //       window.close();
    //     }
    //   }
    // );

    getDateTimeNow()
      .then((date) => setDate(date))
      .catch((err) =>
        message.error("There was an error getting curent date/time")
      );

    edit({
      record: { _id: params.id },
      setState,
      url: `${url}`,
      date_fields,
    });

    return () => {
      // window.removeEventListener("afterprint", listener);
      // window.removeEventListener("beforeprint", before_print_listener);
    };
  }, []);

  const voucher_amount = round(state.voucher_amount);
  let cents = voucher_amount?.toString().split(".")?.[1] || 0;
  cents = cents?.toString().padEnd(2, "0");

  if (cents === "00") {
    cents = "0";
  }

  const words = `**
  ${converter.toWords(voucher_amount || 0).toUpperCase()}${" "}
  AND ${cents}
  /100 PESOS ONLY **`
    .replaceAll(",", "")
    .replaceAll("-", " ");

  return (
    <div>
      <Content
        className={classnames(`inventory-print print screen-m-h-2`, {
          "m-t-4": duplicate,
        })}
      >
        <div>
          <Row>
            <Col span={12}>
              DISBURSEMENT VOUCHER <br />
              <div>
                <span className="has-text-weight-bold">
                  MOM ROSE CHICKEN LECHON
                </span>{" "}
                <br />
                Brgy. Alijis, Bacolod City
                {/* Negros Occidental, 6100 */}
                Tel No. +63 961 993 7041 <br />
                {/* Email: purchasing@advercom.ph */}
              </div>
              <div className="m-t-1">
                <span className="has-text-weight-bold">{`${state.supplier?.name?.toUpperCase()}`}</span>{" "}
                <br />
                {state.supplier?.address?.toUpperCase()}
              </div>
            </Col>
            <Col span={12}>
              <Row>
                <Col span={6}>CV No.</Col>
                <Col span={6}>{state?.cv_no}</Col>
                <Col span={6}>Date</Col>
                <Col span={6}>{moment(state.date).format("MM/DD/YYYY")}</Col>
              </Row>
              <Row>
                <Col span={6}>Check No.</Col>
                <Col span={6}>{state.check_no}</Col>
                <Col span={6}>Check Date</Col>
                <Col span={6}>
                  {moment(state.check_date).format("MM/DD/YYYY")}
                </Col>
              </Row>
              <Row>
                <Col span={6}>Payment Method</Col>
                <Col span={6}>{state.payment_method?.toUpperCase()}</Col>
                <Col span={6}>Reference</Col>
                <Col span={6}>{state.payment_reference?.toUpperCase()}</Col>
              </Row>
              <Row>
                <Col span={6}>Source</Col>
                <Col span={18}>{state.bank?.name?.toUpperCase()}</Col>
              </Row>
            </Col>
          </Row>
          <div className="m-t-1">
            <table className="is-full-width">
              <tbody>
                <tr>
                  <td colSpan={5} className="has-text-weight-bold">
                    **{words}**
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                </tr>
                {(state.items || []).map((o, i) => {
                  return (
                    <tr>
                      <td>PO#{o.po_no}</td>
                      <td>{o.date && moment(o.date).format("MM/DD/YYYY")}</td>
                      <td>{o.expense_category?.name?.toUpperCase()}</td>
                      <td>
                        {o.account?.terms > 0
                          ? `${o.account?.terms || 0} DAYS`
                          : "COD"}
                      </td>
                      <td className="has-text-right">
                        {numberFormat(o.payment_amount)}
                      </td>
                    </tr>
                  );
                })}

                {(state.additional_items || []).map((o, i) => {
                  return (
                    <tr>
                      <td>{o.invoice_no}</td>
                      <td>{o.invoice_date}</td>
                      <td>{o.description}</td>
                      <td>{o.expense_category?.name}</td>
                      <td className="has-text-right">
                        {numberFormat(o.amount)}
                      </td>
                      <td></td>
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="has-text-right">
                    <span className="b-t-1">
                      {numberFormat(
                        sumBy(state.items || [], (o) =>
                          parseFloat(o.payment_amount || 0)
                        ) +
                          sumBy(state.additional_items || [], (o) =>
                            parseFloat(o.amount || 0)
                          )
                      )}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                </tr>

                {(state.debit_memo_items || []).map((o, i) => {
                  return (
                    <tr>
                      <td>DM#{o.dm_no}</td>
                      <td>{o.date?.toUpperCase()}</td>
                      <td>{o.remarks?.toUpperCase()}</td>
                      <td>{o.expense_category?.name?.toUpperCase()}</td>
                      <td className="has-text-right">
                        {numberFormat(0 - o.claim_amount)}
                      </td>
                      <td></td>
                    </tr>
                  );
                })}

                {(state.additional_debit_memo_items || []).map((o, i) => {
                  return (
                    <tr>
                      <td>{o.invoice_no?.toUpperCase()}</td>
                      <td>{o.invoice_date?.toUpperCase()}</td>
                      <td>{o.description?.toUpperCase()}</td>
                      <td>{o.expense_category?.name?.toUpperCase()}</td>
                      <td className="has-text-right">
                        {numberFormat(0 - o.amount)}
                      </td>
                      <td></td>
                    </tr>
                  );
                })}

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="has-text-right">
                    <span className="b-t-1">
                      {numberFormat(state.total_amount)}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="signatories-container">
          <Row gutter={48}>
            <Col span={6} className="has-text-centered">
              Prepared by
            </Col>
            <Col span={6} className="has-text-centered">
              Approved by
            </Col>
            <Col span={6} className="has-text-centered">
              Received by
            </Col>
          </Row>
          <Row gutter={48}>
            <Col span={6}>
              <div>
                &nbsp;
                <div className="signatory">
                  {state.logs?.[state.logs?.length - 1]?.user?.name} <br />{" "}
                  {moment().format("MM/DD/YYYY hh:mm A")}
                </div>
              </div>
            </Col>
            <Col span={6} className="has-text-centered">
              <div>
                &nbsp;
                <div className="signatory"></div>
              </div>
            </Col>
            <Col span={6} className="has-text-centered">
              <div>
                &nbsp;
                <div className="signatory"></div>
              </div>
            </Col>
          </Row>
        </div>
      </Content>
    </div>
  );
}
